'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseThemes;
/**
 * Parses a given theme string.
 */
function parseThemes(themeString, themes) {
  if (!themeString) return [];

  var split = themeString.split(' ');

  return split.map(function (theme) {
    return themes[theme.trim()];
  });
}